module.exports = __webpack_public_path__ + "img/btn-enter.579ec256.png";